import React from 'react';
import { selectCanPublish } from '../snapshotChecker/store/selectors';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';

const publishStatus = () => {
  // Use the canPublish selector - need to call it first as it returns a selector function
  const canPublish = selectCanPublish();

  return {
    disabled: true,
    label: 'Publish',
    render: () =>
      canPublish ? (
        <FontAwesomeIcon
          icon={faCheckCircle}
          style={{ color: 'green', fontSize: '1.5em', paddingRight: '10px' }}
        />
      ) : (
        <img
          className="spinner-img"
          src={'../../../../img/spinner.gif'}
          style={{ paddingRight: '10px' }}
        />
      ),
  };
};

export default publishStatus;
